import type { AccountDetailVO } from "@/api/accounts/type";

import { OrganizationList } from "./components/OrganizationList";
import { useAccountRolesSelection } from "./hooks/useAccountRolesSelection";
import { PermissionDetailPanel } from "./PermissionDetailPanel";
import styles from "./RolesTab.module.css";

/** Tab：身份权限（左组织列表 + 右角色切换与权限详情） */
export const RolesTab = ({
  accountDetail,
  active,
  onStatusChanged,
}: {
  accountDetail: AccountDetailVO | null;
  /** 身份权限 Tab 是否激活，用于控制组织拉取与选中重置 */
  active: boolean;
  onStatusChanged?: () => void | Promise<void>;
}) => {
  const {
    selectedOrg,
    setSelectedOrg,
    selectedRole,
    setSelectedRole,
    employeeOrganizations,
    selectedOrgRoles,
    rolesMap,
  } = useAccountRolesSelection(accountDetail?.id, accountDetail, active);

  return (
    <div className={styles.root}>
      <aside className={styles.sidebar}>
        <OrganizationList
          organizations={employeeOrganizations}
          rolesMap={rolesMap}
          selectedOrg={selectedOrg}
          onSelect={setSelectedOrg}
        />
      </aside>
      <div className={styles.main}>
        <PermissionDetailPanel
          orgRoles={selectedOrgRoles}
          selectedEntityRole={selectedRole}
          onSelectRole={setSelectedRole}
          userId={accountDetail?.id}
          onStatusChanged={onStatusChanged}
        />
      </div>
    </div>
  );
};
